import React, { memo } from 'react';
import { returnQuanity, backgroundChange, showPrice } from './orderUtils';
import styles from './orders.module.scss';
import cn from 'classnames';
import _ from 'lodash';
import { LABEL } from '../../veriables';

const WrapperComponent = memo(({
  openPricePopUp, handleAddToCart, auth, subMenuItemList, btnColor, searchString
}) => {
  return (
    <>
      {(subMenuItemList?.[0]?.items?.length > 0) ? (
        subMenuItemList.map((subMenuList) => (
          <div className={styles.menuItemsList} key={subMenuList.index}>
            {subMenuList.groupName !== 'null' && (
              <div className={cn(styles.menuHeader, 'fw-700 fs-20')}>
                {subMenuList.groupName}
              </div>
            )}
            {subMenuList.items.map((data) => {
              let value;
              if (data !== null) {
                if (data.linkedItem) {
                  value = null;
                }
                value = (
                    <div
                      className={cn(styles.heightWithBag, ((data?.menuItem?.buttonColor) || btnColor) ? '' : 'od-container-card-background', 'od-container-card-border card p-0', '')}
                      key={data.menuItemId}
                      style={{ backgroundColor: backgroundChange(data?.menuItem?.buttonColor, btnColor) }}
                    >
                      <div className={cn('row mx-0 h-100')}>
                        <div
                          className={cn('col-12 od-text-primary text-primary p-1 position-relative btn-ripple')}
                          role="presentation"
                          onClick={() => ((data?.menuItem?.openPrice) ? openPricePopUp(data) : handleAddToCart(data))}
                        >
                          <div className={cn('d-flex col-12 h-100 px-0 mx-0 d-flex align-items-center', styles.alignItemBaseline)}>
                            <div className="fw-700 col-6 align-items-start text-left p-0 od-header-font-family">
                              <span className={cn(styles.lineHeight)}>
                                {data?.menuItem?.name}
                              </span>
                            </div>
                            <div className={cn(JSON.parse(window.sessionStorage.getItem('cart'))?.filter((e) => e.menuItemId === data.menuItemId).length > 0 ? 'od-cart-button color-white' : '', 'fw-700 d-flex col-2 justify-content-center p-0')}>
                              {JSON.parse(window.sessionStorage.getItem('cart'))?.filter((e) => e.menuItemId === data.menuItemId).length > 0
                                   && returnQuanity(JSON.parse(window.sessionStorage.getItem('cart'))?.filter((e) => e.menuItemId === data.menuItemId))}
                            </div>
                            {auth.serverAppFeatures.displayPrice && (
                            <div className="px-0 col-4 text-right">
                              <div className={cn('w-100')}>
                                {showPrice(data, LABEL)}
                              </div>
                            </div>
                            )}
                          </div>
                          {data?.menuItem?.outOfStock && (
                          <div className={cn(styles.outOfStockNumber, 'fs-14 fw-600')}>{LABEL().OUT_OF_STOCK_NUMBER}</div>
                          )}
                        </div>
                        {/* <div
                              role="presentation"
                              className="col-2 align-items-center justify-content-end row mx-0 px-2 od-text-primary text-primary"
                              // onClick={() => handleInfo(data)}
                            >
                              <i className="fa fa-info-circle" aria-hidden="true" />
                            </div> */}
                      </div>
                    </div>
                );
              }
              return value;
            })}
          </div>
        ))) : (
          <>
            {searchString !== '' ? (
              <div className={cn('h-100 d-flex justify-content-center align-items-center p-10 fs-22 text-center')}>
                {LABEL().ITEM_NOT_FOUND}
              </div>
            ) : (
              <div className={cn('h-100 d-flex justify-content-center align-items-center p-10 fs-22 text-center')}>
                {LABEL().MENU_ITEM_NOT_ITEM}
              </div>
            )}
          </>
      )}
    </>
  );
}, (prevProps, nextProps) => {
  return _.isEqual(prevProps, nextProps);
});

export default WrapperComponent;
